
import { Button } from "@/components/atoms"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { getTranslate } from "@/tolgee/server"
import Image from "next/image"

export async function BannerSection() {
  const t = await getTranslate()

  return (
    <section className="container">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
        <div className="py-6 px-6 flex flex-col h-full justify-between rounded-sm">
          <div className="mb-8">
            {/* <span className="text-sm inline-block px-4 py-1 border border-secondary rounded-sm">
              {t("banner_section.tag")}
            </span> */}
            <h1 className="mb-4 heading-lg">
              {t("banner_section.title")}
            </h1>
            <p className="text-lg max-w-lg">
              {t("banner_section.description")}
            </p>
          </div>
        </div>
        <div className="relative aspect-[4/3] mx-auto lg:mx-0 lg:aspect-auto lg:h-full flex justify-end rounded-sm">
          <Image
            src="/fbe/banner-1.jpeg"
            alt={t("banner_section.image_alt")}
            width={700}
            height={600}
            className="object-cover object-top rounded-sm"
            priority
          />
        </div>
      </div>
    </section>
  )
}
